// @flow
import React, { useContext, useEffect, useRef } from 'react';
import { t } from 'Src/i18n';
import { useTracking, type TrackingPayload } from 'Tracking/tracking-api/useTracking';
import {
  AlternativeProposals,
  type AlternativeProposalsProps,
} from 'Components/widgets/alternative-proposals/AlternativeProposals';
import { SidePanel } from 'Components/frameworks/side-panel/SidePanel.jsx';
import { getSuggestionsTrackingData } from 'Components/widgets/alternative-proposals/AlternativeProposalsUtils';
import ReactAppContext from 'Context/ReactAppContext';

type Props = {|
  ...AlternativeProposalsProps,
  trackingDefaultPayload: TrackingPayload,
  onClose: () => void,
|};

export function AlternativeProposalsModal({ trackingDefaultPayload, ...props }: Props) {
  const appContext = useContext(ReactAppContext);
  const modal = useRef();

  const track = useTracking(trackingDefaultPayload);

  const proposal = props.proposals[0];

  useEffect(
    () => {
      const trackingData = getSuggestionsTrackingData({
        proposal,
        suggestions: props.suggestions,
        appContext,
        disableAlternativePrice: props.disableAlternativePrice,
      });
      track(trackingData);
    },
    [proposal],
  );

  return (
    <SidePanel
      ariaLabel={t('booking.counterProposalPopIn.rateCounterProposalTitle')}
      closeLabel={t('common.close')}
      isExpanded
      onClose={event => {
        if (modal.current && !modal.current.contains(event.target)) {
          props.onClose();
          track({ labelGA: 'exit' });
        }
      }}
    >
      <div ref={modal}>
        <AlternativeProposals {...props} />
      </div>
    </SidePanel>
  );
}
